import React from 'react';

import { BaseCardProps } from '../types';

import illustrationEvent from '../../../assets/images/illustrations/secondary/vergrootglas.svg';

const CardImage: React.FC<Pick<BaseCardProps, 'image' | 'fallbackIllustration'>> = (props) => {
  const { image, fallbackIllustration } = props;

  return (
    <div className="Card__image">
      {image && typeof image !== 'string' && image}
      {typeof image === 'string' && <img src={image} alt="" />}
      {!image && (
        <img className="Card__image__fallback" src={fallbackIllustration || illustrationEvent} alt="" />
      )}
    </div>
  );
};

export default CardImage;
